import React from "react";
import { TranslationText } from "components/TextTranslationContainer";
import CategoryListItem from "./CategoryListItem";

function CategoriesList({
  categoriesList,
  categoryItemStyles = {
    wrapper: {},
    item: {},
  },
  categoryWrapperStyles = {},
  headingWrapperStyles = {},
  showHeading = false,
  showIcon = false,
  scrollOffset, 
  showSeeAll = true,
}) {

  const show_icon = React.useMemo(() => {
    return showIcon || categoriesList?.some((category) => category?.categoryId?.imageUrl) || false;
  }, [categoriesList]);
  
  if(categoriesList?.length <= 0) return null;
  
  return (
    <React.Fragment>
      {showHeading && (
        <div
          className={`flex justify-between items-center pt-4 ${headingWrapperStyles.className || ""}`}
          style={headingWrapperStyles.style || {}}
        >
          <TranslationText className="text-20x font-bold" text="Categories" />
          {showSeeAll && <TranslationText className="text-12x text-shadow-forge-500" text="See all" />}
        </div>
      )}

      <nav
        className={`bg-white flex overflow-auto py-3 cursor-pointer gap-4 ${categoryWrapperStyles.className || ""}`}
        style={categoryWrapperStyles.style || {}}
      >
        {categoriesList?.map((category, index) => (
          <CategoryListItem
            key={index}
            category={category?.categoryId}
            {...categoryItemStyles}
            showIcon={show_icon}
            iconUrl={category?.categoryId?.imageUrl}
            scrollOffset={scrollOffset}
          />
        ))}
      </nav>
    </React.Fragment>
  );
}

export default CategoriesList;
